import { Entity, IEntity } from "./Entity";
import { IApp03Epic } from "./App03Epic";

export interface IApp03EpicDep extends IEntity {
    EpicID?: number;              // The main epic (depends on another)
    DependentEpicID?: number;     // The epic it depends on
    Epic?: IApp03Epic;            // Parent epic reference
    DependentEpic?: IApp03Epic;   // Dependency epic reference
}

export class App03EpicDep extends Entity implements IApp03EpicDep {
    public EpicID = null;
    public DependentEpicID = null;

    constructor() {
        super();
    }
}
